import { render, staticRenderFns } from "./App.vue?vue&type=template&id=aba5b9f2&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aba5b9f2')) {
      api.createRecord('aba5b9f2', component.options)
    } else {
      api.reload('aba5b9f2', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=aba5b9f2&", function () {
      api.rerender('aba5b9f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/App.vue"
export default component.exports